<template>
    <div class="paging">
        <ul>
            <li class="paging-btn"><img src="./images/left.png" v-on:click="prvePage(curIndex)"></li>
            <li v-for="index in indexs"  v-bind:class="{ active: curIndex == index }" >
                <a v-on:click="btnClick(index)" class="paging-item">{{ index < 1 ? "..." : index }}</a>
            </li>
            <li class="paging-btn"><img src="./images/right.png" v-on:click="nextPage(curIndex)"
                                        style="float:right;"></li>
        </ul>
    </div>
</template>
<style lang="scss" scoped>
    .paging {
        li {
            list-style: none;
            display: inline-block;
            margin-right: 8px;
            cursor: pointer;
        }
        .paging-btn{
            width: 26px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            padding-top: 5px;
            img{
                text-decoration: none;
                width: 10px;
                height: 17px;
                float: left;
                cursor: pointer;
            }

        }
        .paging-item {
            text-decoration: none;
            background-color: #ededed;
            float: left;
            width: 36px;
            min-width: 36px;
            height: 26px;
            line-height: 26px;
            color: #666;

            font-size: 14px;
        }
        .active a {
            color: #fff;
            cursor: default;
            background-color: #364983;
        }
        .pageBut-disabled {
            color:#ddd !important;
        }
    }

</style>
<script>

    module.exports = Vue.component('commonPagination',{
        data(){
            return{
                curIndex: 1
            }
        },
        components:{

        },
        props: ['pageIndex', 'totalNum'],
        computed: {
            indexs: function (){
                let left = 1;
                let right = this.totalNum;
                let itemArr= [];
                // if (this.totalNum >= 5) {
                //     if (this.curIndex > 3 && this.curIndex < this.totalNum - 3) {
                //         left = this.curIndex - 3;
                //         right = this.curIndex + 3;
                //     } else {
                //         if (this.curIndex <= 4) {
                //             left = 1;
                //             right = 6;
                //         } else {
                //             right = this.totalNum;
                //             left = this.totalNum - 5;
                //         }
                //     }
                // }
                if (this.totalNum > 5) {
                    if (this.curIndex > 3 && this.curIndex <= this.totalNum - 3) {
                        left = this.curIndex - 3;
                        right = this.curIndex + 3;
                    } else {
                        if (this.curIndex <= 4) {
                            left = 1;
                            right = 6;
                        } else {
                            right = this.totalNum;
                            left = this.totalNum - 5;
                        }
                    }
                }
                // console.log('left:'+left+'right:'+right);
                while (left <= right) {
                    itemArr.push(left);
                    left++;
                }
                if (itemArr[0] > 1) {
                    itemArr[0] = 1;
                    itemArr[1] = -1;
                }
                if (itemArr[itemArr.length - 1] < this.totalNum) {
                    itemArr[itemArr.length - 1] = this.totalNum;
                    itemArr[itemArr.length - 2] = 0;
                }
                return itemArr;
            }
        },
        methods: {
            // 页码点击事件
            btnClick: function (index) {
                if (index < 1) {
                    return;
                } else {
                    if (index != this.curIndex) {
                    this.curIndex = index;
                    this.$emit('changeItem', index);
                }
            }
        },
        // 下一页
        nextPage: function (index) {
            if (this.curIndex >= this.totalNum) {
                return;
            } else {
                this.btnClick(this.curIndex + 1);
            }
        },
        // 上一页
        prvePage: function (index) {
            if (this.curIndex <= 1) {
                return;
            } else {
                this.btnClick(this.curIndex - 1);
            }
        }
    }
})
</script>



// WEBPACK FOOTER //
// src/components/common/commonPagination/commonPagination.vue